export class HelpdeskObject {
  title = "";
  infos: { [key: string]: string } = {};
  jsessionId = "";
  version = "";
}
